const PageSelectorContainerStyle = `
  grid-auto-columns: 25px;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  justify-content: center;
  padding: 44px 0 9px;
`;

export default PageSelectorContainerStyle;
